// Load more articles functionality
const loadMoreButton = document.querySelector('.js-load-more-articles');

if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function () {
        const hiddenArticles = document.querySelectorAll('.hero-articles__article--hidden');
        const articlesToShow = 9; // Show 9 more articles each time
        let shown = 0;

        hiddenArticles.forEach(article => {
            if (shown < articlesToShow) {
                article.classList.remove('hero-articles__article--hidden');
                shown++;
            }
        });

        // Hide button if no more hidden articles
        const remainingHidden = document.querySelectorAll('.hero-articles__article--hidden');
        if (remainingHidden.length === 0) {
            this.style.display = 'none';
        }
    });
}